import React from 'react';

import { PriorityImage } from '@swf/poker';

import { PASS_IMAGES } from '../../../../constants';
import type { Pass, PassType } from '../../../../types';

import {
  TXTCLI_Overview_page_bundle_show_pass_ELL,
  TXTCLI_Overview_page_bundle_tournamen_ELL
} from './ImgCard.messages.json';
import styles from './ImgCard.scss';

interface Props {
  card: Pass | { type: PassType; tallPromoImage: string };
  onClick: () => void;
}
const ImgCard: React.FC<Props> = ({ onClick, card }) => {
  const imgUrl = card.tallPromoImage;
  const { type } = card;
  const subImage = PASS_IMAGES[type];

  return (
    <div className={styles.wrapper} onClick={onClick}>
      <div className={styles.imageWrapper}>
        <PriorityImage
          altText={TXTCLI_Overview_page_bundle_tournamen_ELL.defaultMessage}
          className={styles.image}
          fetchPriority="high"
          imageUrl={imgUrl}
        />
      </div>
      <div className={styles.subImageWrapper}>
        <PriorityImage
          altText={TXTCLI_Overview_page_bundle_show_pass_ELL.defaultMessage}
          className={styles.subImage}
          imageUrl={subImage}
          fetchPriority="high"
        />
      </div>
    </div>
  );
};
export default ImgCard;
